import axios from 'axios';
import { getToken } from '@iso/lib/helpers/utility';
import { put, select } from 'redux-saga/effects';
import actions from '../../redux/auth/actions';

const timeout = 60000;
const apiUrl = process.env.REACT_APP_KOTLIN_API_URL;

let headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
};

export function* get(uri, data, page, sort, token) {
    const sessionToken = getToken().get('idToken') ? getToken().get('idToken') : token ? token : null;
    headers = {
        ...headers,
        authorization: `Bearer ${sessionToken}`,
    };
    if (page) {
        headers = {
            ...headers,
            Range: `${page.page || 1}-${page.limit || 10}`,
        };
    }
    if (!sort) {
        sort = {
            sort: 'asc',
            sortBy: 'createdAt',
        };
    }
    const params = data ? toParams(data) : '';
    const sortField = `&sort=${sort.sort === 'asc' ? '' : '-'}${sort.sortBy}`;
    return yield fetch(`${apiUrl}${uri}?${params}${sortField}`, {
        headers: headers,
        method: 'GET',
    });
}

export function* kotlinApiEncryptedGet(uri, data, page, sort) {
    if (page) {
        headers = {
            ...headers,
            Range: `${page.page || 1}-${page.limit || 10}`,
        };
    }
    if (!sort) {
        sort = {
            sort: 'asc',
            sortBy: 'createdAt',
        };
    }
    const params = data ? toParams(data) : '';
    const sortField = `&sort=${sort.sort === 'asc' ? '' : '-'}${sort.sortBy}`;
    return yield kotlinApiEncryptedFetch(`${apiUrl}${uri}?${params}${sortField}`, {
        headers: headers,
        method: 'GET',
    });
}

export function* kotlinApiEncryptedPost(uri, data) {
    return yield kotlinApiEncryptedFetch(`${apiUrl}${uri}`, {
        headers: headers,
        method: 'POST',
        data,
    });
}

export function* kotlinApiEncryptedPut(uri, data) {
    return yield kotlinApiEncryptedFetch(`${apiUrl}${uri}`, {
        headers: headers,
        method: 'PUT',
        data,
    });
}

export function* kotlinApiEncryptedDelete(uri, data) {
    return yield kotlinApiEncryptedFetch(`${apiUrl}${uri}`, {
        headers: headers,
        method: 'DELETE',
        data,
    });
}

// Helpers
function toParams(data) {
    const url = Object.keys(data).map((k) => {
        return `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`;
    }).join('&');
    return url;
}

function* forbidden() {
    yield localStorage.setItem('forbidToken', 1);
    yield put({
        type: actions.CHECK_AUTHORIZATION,
    });
}

export function* kotlinApiEncryptedFetch(url, options) {
    const state = yield select();
    const keys = state.EncryptDecrypt.encryptReqIdSuccess;
    if (keys) {
        headers = {
            ...headers,
            ...keys
        }
    }
    return yield fetch(url, options)
}

export function* fetch(url, options) {
    const result = yield axios.request({
        ...options,
        url,
        baseURL: apiUrl,
        timeout: timeout,
        headers: headers
    }).then((res) => {
        return res;
    }).catch((error) => {
        return error
    })
    try {
        const response = result.status ? result : result.response ? result.response : null;
        if (!response) return null;
        if (response.status === 401 || response.status === 403) return yield forbidden()
        if (!response.data || response.data instanceof Blob) return response;

        return response;
        // Verify response data
        // const { payload } = verify(response.data, process.env.REACT_APP_ENV_KEY);
        // if (typeof payload === 'string') {
        //     try {
        //         const parsedPayload = JSON.parse(payload);
        //         return {...response, data: parsedPayload };
        //     } catch (e) {
        //         // Detect base64 the convert to blob
        //         return {...response, data: payload };
        //     }
        // }
        // return {...response, data: payload };
    } catch (error) {
        return error
    }
}
